import { isBuildPhase } from '@/constant/env';
import { Header } from './Header';
import { transformStrapiHeader } from './transformer';
import { cms } from '@/cms';

export async function HeaderStrapi({ documentId }: { documentId: string }) {
  if (!documentId) {
    throw new Error('Header document ID is required');
  }

  const { data } = await cms.getHeaderByDocumentId(documentId);

  const headerData = data?.attributes;

  if (!headerData) {
    if (isBuildPhase) throw new Error(`Header with ID ${documentId} not found`);
    return null;
  }

  if (!headerData) return null;

  return <Header {...transformStrapiHeader(headerData)} />;
}
